import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { HandleMissedActivitiesJustificationsUseCaseInterface } from 'domain/usecases';

interface IMissedActivitiesJustifications {
  data: HandleMissedActivitiesJustificationsUseCaseInterface.Result;
}

interface IPayloadData
  extends PayloadAction<HandleMissedActivitiesJustificationsUseCaseInterface.Result> {}

const initialState: IMissedActivitiesJustifications = {
  data: null,
};

export const MissedActivitiesJustificationsSlice = createSlice({
  name: 'missed-activities-justifications',
  initialState,
  reducers: {
    loadMissedActivitiesJustifications: (state, action: IPayloadData) => {
      state.data = action.payload;
    },
    clearMissedActivitiesJustifications: (state) => {
      state.data = null;
    },
  },
});

export const {
  loadMissedActivitiesJustifications,
  clearMissedActivitiesJustifications,
} = MissedActivitiesJustificationsSlice.actions;

export default MissedActivitiesJustificationsSlice.reducer;
